import { NgModule } from "@angular/core";
import { HexButtonModule } from "@hex/angular/button";
import { HexTextModule } from "@hex/angular/text";
import { OverridesModule } from "../presentational/overrides/overrides.module";
import { TogglePostActionComponent } from "./toggle-post-action.component";

@NgModule({
    imports: [
        HexButtonModule,
        HexTextModule,
        OverridesModule,
    ],
    exports: [
        ...[
            TogglePostActionComponent,
        ],
    ],
    declarations: [
        TogglePostActionComponent,
    ],
    providers: [],
})
export class TogglePostActionModule {
}
